<template>
  <div>
    <div id="particles-bg">
      <particles-bg color="#f7941e" num="7" type="cobweb" :bg="true" />
    </div>
<!--    <span v-for="content in contents" :key="content.id_content">-->
<!--      &lt;!&ndash; <span v-if="index == 0"> &ndash;&gt;-->
<!--      <div id="content">-->
<!--        <Content-->
<!--          :title="content.title"-->
<!--          :description="content.description"-->
<!--        ></Content>-->
<!--      </div>-->
<!--      <img class="circle" src="../assets/circle.svg" alt="" />-->
<!--    </span>-->
    <h1>{{ contents.find(content => content.id_content === 101)?.title }}</h1>
    <span v-if="actualPage.length != 0">
      <span
        v-for="application in actualPage.slice().reverse()"
        :key="application.jobs_id"
      >
        <Applications
          :id="application.jobs_id"
          :title="application.name"
          :description="application.description"
          :offer="application.offer"
          :profile="application.profile"
        ></Applications>
      </span>
    </span>
    <span v-else
      ><h3>{{ contents.find(content => content.id_content === 102)?.title }}</h3></span
    >
    <nav id="pagination" aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" v-for="page in pages" :key="page.n">
          <span v-if="pages.length != 1">
            <button class="btn" @click="changePage(page.n)">
              {{ page.n }}
            </button></span
          >
        </li>
      </ul>
    </nav>
    <img class="circle" src="../assets/circle.svg" alt="" />
    <h1 id="spontaneous">{{ contents.find(content => content.id_content === 100)?.title }}</h1>
    <div id="form">
      <FormSpontaneous :contents="contents"></FormSpontaneous>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import FormSpontaneous from "../components/FormSpontaneous";
import { ParticlesBg } from "particles-bg-vue";
import Applications from "../components/Applications";
import Footer from "../components/Footer";
// import Content from "@/components/Content";
import { mapGetters } from "vuex";

export default {
  name: "Carrers",
  components: {
    Applications,
    Footer,
    FormSpontaneous,
    ParticlesBg,
    // Content,
  },
  data: function() {
    return {
      applications: [],
      length: "",
      totalPage: "",
      pages: [],
      currentPage: 1,
      actualPage: [],
      jobs: [],
      scrolledToBottom: false,
      perPage: 5,
      noJobs: "",
      contents: [],
    };
  },
  mounted() {
    this.getAllJobs();
    this.getAllContent();
  },
  methods: {
    async getAllJobs() {
      try {
        await this.$store.dispatch("fetchJobs");
        for (let i = 0; i < this.getJobs.data.length; i++) {
          if (
            this.getJobs.data[i].del == 0 &&
            this.getJobs.data[i].state == 0 &&
            this.getJobs.data[i].jobs_id != 0
          ) {
            this.jobs.push(this.getJobs.data[i]);
          }
        }
        this.noJobs = this.getNoJobs;
        this.getNumbers();
        this.changePage(1);
      } catch (err) {
        this.$router.push({ name: "Error" });
      }
    },
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page === 4) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({ name: "Error" });
      }
    },
    async getNumbers() {
      this.length = this.jobs.length;
      this.totalPage = Math.ceil(this.length / this.perPage);
      for (let i = 1; i <= this.totalPage; i++) {
        this.pages.push({ n: i });
      }
    },
    async prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.changePage(this.currentPage);
      }
    },
    async nextPage() {
      if (this.currentPage < this.totalPage) {
        this.currentPage++;
        this.changePage(this.currentPage);
      }
    },
    async changePage(page) {
      if (page < 1) page = 1;
      if (page > this.totalPage) page = this.totalPage;
      this.currentPage = page;
      this.actualPage = [];
      for (let i = (page - 1) * this.perPage; i < page * this.perPage; i++) {
        if (this.jobs[i] != null) {
          this.actualPage.push(this.jobs[i]);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["getJobs"]),
    ...mapGetters(["getNoJobs"]),
    ...mapGetters(["getContent"]),
  },
};
</script>
<style scoped>
.container {
  padding: 50px;
}
h3 {
  text-align: center;
}
h1 {
  text-align: center;
  padding: 50px 0px 0px 0px;
}
.circle {
  padding: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
#spontaneous {
  padding: 0px 0px 50px 0px;
}
#form {
  padding: 0px 200px 0px 200px;
}
h1 {
  font-size: 60px;
  font-family: "Barlow", sans-serif;
  font-weight: 500;
}
#pagination {
  padding-top: 50px;
}
nav ul li button {
  border: 2px solid #f7941e;
  margin-right: 5px;
  margin-left: 5px;
  font-size: 18px;
}
nav ul li button:hover,
nav ul li button:focus {
  color: white;
  background-color: #f7941e;
  text-decoration: #f7941e;
  box-shadow: none;
}
#particles-bg {
  position: fixed;
  /* fill the entire page */
  width: 100%;
  height: 100%;
  /* remove the space along the edges */
  margin: 0;
  padding: 0;
  /* position it to start at the top of the page */
  top: 0;
  /* put it behind other content */
  z-index: -1;
}
@media (max-width: 1000px) {
  #form {
    padding: 0px 0px 0px 0px;
  }
  h1 {
    font-size: 50px;
  }
}
</style>
